import { create } from 'zustand';

interface InputStore {
    inputValue: string;
    setInputValue: (value: string) => void;
}

export const useInputStore = create<InputStore>((set) => ({
    inputValue: '',
    setInputValue: (value: string) => set({ inputValue: value }),
}));
